import Vue from 'vue';
import Vuex from 'vuex';
import { getDicts } from '@/api/index.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 全局loading动画
    loading: false,
    // 记录所有请求，用于切换页面时取消
    requests: [],
    dicts: {},
    globalDialogVisible: false,
    minPath: 'pages/index/index',
  },
  mutations: {
    loadStatus(state, boolean) {
      state.loading = boolean;
    },
    addRequest(state, string) {
      state.requests.push(string);
    },
    setGlobalDialogVisible(state, payload) {
      let { visible, path } = payload;
      // debugger;
      if (path) {
        state.minPath = path;
      } else {
        state.minPath = 'pages/index/index';
      }
      state.globalDialogVisible = visible;

    },
  },
  actions: {
    async getDict({ state }) {
      let res = await getDicts();
      
      // 处理字典数据，支持下划线和驼峰两种命名
      const dictData = res.data || {};
      
      // 将下划线命名转换为驼峰命名，方便前端使用
      state.dicts = {
        ...dictData,
        // 支持下划线命名
        activityCategory: dictData.activity_category || dictData.activityCategory || [],
        emergencyLevel: dictData.emergency_level || dictData.emergencyLevel || [],
        newsType: dictData.news_type || dictData.newsType || [],
        organizationType: dictData.organization_type || dictData.organizationType || [],
        serviceTarget: dictData.service_target || dictData.serviceTarget || [],
        serviceType: dictData.service_type || dictData.serviceType || [],
        miniWishType: dictData.mini_wish_type || dictData.miniWishType || [],
      };
    },
  },
});
